import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, computed, effect, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, forkJoin } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { Dossier } from '../../bo/dossier';
import { Site } from '../../bo/site';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { environment } from 'src/environments/environment';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';
import { OrganizationDto } from 'src/app/bo/organization';
import { MetabaseService } from 'src/app/services/metabase.service';

@Component({
  selector: 'app-mon-site',
  templateUrl: './mon-site.component.html',
  styleUrls: ['./mon-site.component.scss'],
  standalone: false
})
export class MonSiteComponent {
  id = signal<any>(undefined);
  estClient = signal<boolean>(false);
  monSite: Site;
  hauteurListe = signal<number>(0);
  erreurRecuperation = signal<boolean>(false);
  dossierRacine = signal<Dossier>(undefined);
  donneeInit = signal<boolean>(false);
  tab = signal<number>(1);
  isOpen = signal<boolean>(false);
  isOpenSub = signal<boolean>(false);
  blastIdToZoom = signal<number>(null);
  private readonly subscriptions: Subscription = new Subscription();
  organizations = signal<OrganizationDto[]>([]);
  private readonly DASHBOARD_SITE_IDS = [41, 594, 605];
  canShowDashboard = computed(() => {
    const siteId = this.userDataService.currentSite()?.siteId;
    return siteId != null && this.DASHBOARD_SITE_IDS.includes(siteId);
  });
  dashboardUrl = signal<string | undefined>(undefined);
  private readonly currentSiteId = computed(() => this.userDataService.currentSite()?.siteId);

  constructor(
    private readonly route: ActivatedRoute,
    protected userDataService: UtilisateurService,
    private readonly userProfilService : KeycloakUtilisateurService,
    private readonly http: HttpService,
    private readonly router: Router,
    private readonly fonctionsService: FonctionsService,
    private readonly userService: KeycloakUtilisateurService,
    public utilService: UtilisateurService,
    private readonly metabaseService: MetabaseService
  ) {
    this.monSite = new Site();

    this.getScreenSize();

    effect(() => {
      const currentSite = this.userDataService.currentSite();
      if (!currentSite) return;
      if (currentSite.siteId != 189 && this.tab() === 3) {
        this.tab.set(1);
      }
    });

    effect(() => {
      const siteId = this.currentSiteId();
      if (this.tab() !== 4 || siteId == null) return;
      this.loadDashboardUrl();
    });
  }

  private async loadDashboardUrl(): Promise<void> {
    const siteId = this.userDataService.currentSite()?.siteId;
    if (siteId == null) {
      this.dashboardUrl.set(undefined);
      return;
    }

    try {
      const url = await this.metabaseService.getMetabaseSiteUrl(siteId);
      this.dashboardUrl.set(url != null && url.trim().length > 0 ? url : undefined);
    } catch {
      this.dashboardUrl.set(undefined);
    }
  }

  // si la fenêtre change de taille
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.hauteurListe.set(100);
  }

  ngOnInit() {
    this.userService.getCurrentUserOrganizations().then((organizations: OrganizationDto[]) => {
      this.organizations.set(organizations);
    });

    this.estClient.set(this.userProfilService.isGuest);

    // Écouter les queryParams pour le blastId
    const queryParamsSub = this.route.queryParams.subscribe(queryParams => {
      if (queryParams['blastId']) {
        this.blastIdToZoom.set(Number.parseInt(queryParams['blastId'], 10));
        this.changerTab(1);
      }
    });
    this.subscriptions.add(queryParamsSub);

    const sub = this.route.params.subscribe(p => {  //Abonnement au changement de paramètre
    
   if(this.userDataService.currentSite()?.region?.orgId !=18)
    {
        this.changerTab(1); 
    }
    
      if (p.id == undefined) { //currentSite n'a pas encore été définit, cookie currentSite inexistant
        this.monSite = this.userDataService.currentSite();
        this.router.navigate(['mysite', this.userDataService.currentSite()?.siteId], { replaceUrl: true });
      } else {
        var startLoader = setTimeout(() => {
          this.fonctionsService.loading_screen(true);
        }, 300);
        const requetes = [this.http.get<Site>('Sites/' + p.id), this.http.get<Dossier>('Sites/' + p.id + '/Folder')];

        forkJoin(requetes).subscribe(resultats => {
          this.monSite = resultats[0] as Site;

          this.userDataService.setCurrentSite(resultats[0] as Site);
          this.dossierRacine.set(resultats[1] as Dossier);
          this.donneeInit.set(true);
          this.fonctionsService.loading_screen(false);
          clearTimeout(startLoader);
        }, (error: HttpErrorResponse) => {
          if (error.status === undefined) {
            // Redirect to Keycloak logout
            const logoutUrl = `${environment.keycloakUrl}${environment.keycloakLogoutPath}?post_logout_redirect_uri=${encodeURIComponent(environment.postLogoutRedirectUri)}&client_id=${environment.clientId}`;
            window.location.href = logoutUrl;
          } else {
            if (error.status === 401 || error.status === 403) {
              console.log(error.error); 
            }
            this.fonctionsService.loading_screen(false);
            this.erreurRecuperation.set(true);
          }

          clearTimeout(startLoader);
        });
      }
    });
    this.subscriptions.add(sub);
  }

  private ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  changerTab(numTab: number) {
    this.tab.set(numTab);

    if (this.tab() == 3) {
      this.dropdownClose();
    }
  }

  modifDossier(d: Dossier) {
    this.dossierRacine.set(d);
  }

  protected dropdownShow() {
    this.isOpen.set(true);
  }
  protected dropdownClose() {
    this.isOpen.set(false);
    this.isOpenSub.set(false);
  }
  protected submenuShow() {
    this.isOpenSub.set(true);
  }
  protected submenuClose() {
    this.isOpenSub.set(false);
  }

  
}
